
<template>
<div>
    <div><img style="display: none;" src='https://www.cancer.org.br/wp-content/uploads/2020/08/logo_fundacao-e1553698988600-1.png'></div>
    <a v-if="!admin" href='#' @click="goTo({path: '/mf/home' })" class='back-button'> <font-awesome-icon title='Voltar' icon="fa-arrow-left" /> </a>
    <table class='donations-table'>
    <thead>
      <tr> <th colspan='7'> Doações </th></tr>
      <tr>
        <th> Valor </th>
        <th> Situação </th>
        <th> Recorrente </th>
        <th> Tipo </th>
        <th> Criado em </th>
        <th> Cancelado em </th>
        <th> Ações </th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(donation) in donations" :key="donation.id">
        <td> {{donation.amount}}                    </td>
        <td> {{donation.state}}                     </td>
        <td> {{donation.recurring ? 'Sim' : 'Não'}} </td>
        <td> {{donation.payment_form}}              </td>
        <td> {{donation.created_at}}                </td>
        <td> {{donation.canceled_at}}               </td>
        <td>
        <!--
          <a :href="'#/mf/doacao/'+donation.id" v-if="donation.recurring">
            <font-awesome-icon title='Editar doação' icon="fa-pen-to-square" />
          </a>
        -->
          <a href='#'  @click="printReceipt(donation.id)" >
            <font-awesome-icon class='icon' title='Baixar recibo' icon="fa-print" />
          </a>

          <a href='#' @click="goTo({path: '/mf/doacao/'+donation.id+'/recibos', event: 'listReceipts', donationId: donation.id })" v-if="donation.recurring">
            <font-awesome-icon class='icon' title='Detalhes da doação' icon="fa-up-right-and-down-left-from-center" />
          </a>

          <a href='#' @click="cancelDonation(donation.id)" v-if="donation.recurring && !donation.canceled_at">
            <font-awesome-icon class='icon' title='Cancelar doação' icon="fa-ban" />
          </a>

          <a href='#' @click="goTo({path: '/mf/doacao/'+donation.id+'/editar', event: 'valueForm', donationId: donation.id })" v-if="donation.recurring && !donation.canceled_at">
            <font-awesome-icon class='icon' title='Atualizar doação' icon="fa-square-pen" />
          </a>
        </td>
      </tr>
    </tbody>
    </table>
    <div id='print-content'>
      <p> </p>
    </div>
  </div>
</template>

<style type="text/css">
    @import url("https://donatorarea.s3.amazonaws.com/assets/bootstrap/css/bootstrap.min.css");
    @import url("https://donatorarea.s3.amazonaws.com/assets/css/font-awesome.min.css");
    .donations-table{
        border: 2px solid #55006D;
        margin: auto;
        margin-top: 20px;
    }
    .donations-table td, .donations-table th{
      border: 2px solid #55006D;
      border-collapse: collapse;
      padding:8px 16px;
    }
    .donations-table th{
      text-align: center;
      background: none;
    }
    .donations-table a {
      color: inherit;
    }
    .icon {
      padding: 2px;
    }

    #print-content {
      display: none;
    }

    @media print {
      #print-content {
        display: block;
      }

      .donations-table {
        display: none;
      }
    }
</style>

<script>
import { setupAxios } from '../../setupAxios';
import { hasTokenExpired } from '../../localStorageManager';
import { printReceipt } from '../utils';
import { getDonations, getDonationsFromAdmin } from '../../apiClient';

export default {
  name: 'ListDonations',
  props: {
    admin: { type: Boolean, default: false },
    donator_id: { type: Number }
  },
  data: () => ({
    donations: []
  }),
  mounted: async function () {
    this.axios = setupAxios();
    const token = !hasTokenExpired() ? localStorage.getItem('token') : undefined;
    if (token) {
      await this.getDonations();
    }
  },
  methods: {
    async getDonations () {
      const result = this.admin ? await getDonationsFromAdmin(this.axios, this.donator_id) : await getDonations(this.axios);
      this.donations = result.data;
    },
    async cancelDonation (donationId) {
      const headers = {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      };

      await this.axios.delete(`/api/v2/donation/${donationId}`, headers);
      await this.getDonations();
    },
    printReceipt (donationId) {
      const donation = this.donations.find(d => d.id === donationId);
      printReceipt(donation);
    },
    goTo (params) {
      if (this.admin) {
        this.$emit(params.event, { donationId: params.donationId, event: params.event });
      } else {
        this.$router.push({ path: params.path });
      }
    }
  }
};
</script>
